import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFnsV3";
import { de } from "date-fns/locale";
import { enUS } from "date-fns/locale/en-US";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

interface Props {
  children: ReactNode;
}

export function MuiLocalizationProvider({ children }: Props) {
  const { i18n } = useTranslation();

  return (
    <LocalizationProvider
      adapterLocale={getAdapterLocale(i18n.language)}
      dateAdapter={AdapterDateFns}
    >
      {children}
    </LocalizationProvider>
  );
}

function getAdapterLocale(lang: string) {
  if (lang.startsWith("en")) return enUS;
  else return de;
}
